{
  "instances": {
    "beans": {
      "label": "Beans",
      "name": "Name",
      "aliases": "Aliase",
      "type": "Typ",
      "resource": "Ressource",
      "dependencies": "Abhängigkeiten"
    }
  }
}
